<template>
    <div class="form-demo">
        <el-form label-width="80px" :model="form" size="mini">
            <el-form-item label="产品名称:">
                <el-input v-model="form.name" placeholder="请输入产品名称"></el-input>
            </el-form-item>
            <el-form-item label="产品类别:">
                <el-select v-model="form.region" placeholder="请选择类别">
                    <el-option label="单品" value="1"></el-option>
                    <el-option label="酸奶" value="0"></el-option>
                    <el-option label="大奶" value="0"></el-option>
                    <el-option label="赠品" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否上架:">
                <el-switch v-model="form.deliver"></el-switch>
            </el-form-item>
            <el-form-item label="产品类别:">
                <el-checkbox-group v-model="form.type">
                    <el-checkbox label="单品" name="type" value="0"></el-checkbox>
                    <el-checkbox label="套装" name="type" value="1"></el-checkbox>
                    <el-checkbox label="大奶" name="type" value="2"></el-checkbox>
                    <el-checkbox label="赠品" name="type" value="3"></el-checkbox>
                    <el-checkbox label="福利社" name="type" value="4"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="产品日期:">
                <el-date-picker v-model="form.date" type="datetime" placeholder="请选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="活动范围:">
                <el-date-picker v-model="form.date1" type="datetimerange" range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="上传图片:">
                <el-upload class="" drag mutiple action="" :file-list="form.fileList" list-type="picture">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">立即提交</el-button>
                <el-button type="danger" >取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default{
        data(){
            return {
                form:{
                    name:'',
                    type:'state',
                    fileList:[
                        {
                            name:'图片1',
                            url:'http://resourcetest.lechun.cc/imgStorage/3153194066088815088.jpg'
                        },
                        {
                            name:'图片2',
                            url:'http://resourcetest.lechun.cc/imgStorage/3153194066088815088.jpg'
                        },
                    ]
                }
            }
        },
        methods:{
            onSubmit(){
                this.$message({
                    message:'提交成功',
                    type:'success'
                })
            }
        }
    }
</script>

<style scoped>
    .form-demo{
        margin: 10px;
        height: 750px;
        overflow-y: scroll;
    }
</style>


// WEBPACK FOOTER //
// src/views/baseform.vue